<template>
    <div>
        <div v-if="headers" class="d-flex black--text justify-space-between">
            <div v-for="header in headers" :key="header">
                {{$translate(header)}}
            </div>
        </div>
        <div class="d-flex">
            <v-checkbox :label="label" v-model="setting.check" @change="emitValue" class="flex-grow-1" color="zoezi-edit-color" />
            <v-switch v-model="setting.toggle" @change="emitValue" color="zoezi-edit-color" :disabled="!setting.check" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-check-toggle-setting',

    props: ['value', 'label', 'headers'],

    data: () => ({
        setting: null
    }),

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.setting = {check: value && value.check, toggle: value && value.toggle};
            }
        }
    },

    methods: {
        emitValue() {
            this.$emit('input', this.setting)
        }
    }
}
</script>
